module.exports = __webpack_public_path__ + "02_short_brown.718adb04.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/02_short_brown.png
// module id = IQNu
// module chunks = 0